define('app/factories/modal_factory',['app/setup', 'app/views/modal_view'],
  function(takhfifan, modalView) {
    return new takhfifan.modalView();
});

